<template>
  <article class="gh-list-item">
    <GenerationHistoryListItemHead
      :service-name-key="serviceNameKey"
      :project-name="item.project_name"
      :datetime="item.request_datetime_ts"
    />
    <div class="gh-list-item__body gh-list-item__body--half">
      <div class="gh-list-item__left">
        <div class="gh-list-item__preview">
          <div class="gh-list-item__preview-text">
            <vue-markdown
              :source="previewText"
              :task-lists="false"
              class="markdown-custom"
            ></vue-markdown>
          </div>
        </div>
        <button
          type="button"
          class="gh-list-item__view-all"
          @click="$emit('view-all', item.project_id)"
        >
          {{ $t(viewAllKey, { count: item.total_count }) }}
        </button>
      </div>
      <div class="gh-list-item__right">
        <GenerationHistoryMetaRows
          :fields="inlineFields"
          variant="inline"
          :row-key-prefix="`naming-${item.project_id}`"
        />
      </div>
    </div>
  </article>
</template>

<script>
import {
  getListInlineMetaFields,
  getListLeftPreview,
  getServiceNameKey,
  getViewAllLinkKey,
} from '@/shared/helpers/generationHistory';
import GenerationHistoryListItemHead from '../shared/GenerationHistoryListItemHead.vue';
import GenerationHistoryMetaRows from '../shared/GenerationHistoryMetaRows.vue';
import VueMarkdown from 'vue-markdown';

export default {
  name: 'GenerationHistoryListItemNaming',
  components: {
    GenerationHistoryListItemHead,
    GenerationHistoryMetaRows,
    'vue-markdown': VueMarkdown,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    serviceNameKey() {
      return getServiceNameKey(this.item.project_type);
    },
    viewAllKey() {
      return getViewAllLinkKey(this.item.project_type, this.item);
    },
    previewText() {
      const preview = getListLeftPreview(this.item, this.item.project_type);
      return preview.text || '';
    },
    inlineFields() {
      return getListInlineMetaFields(this.item, (key) => this.$t(key));
    },
  },
};
</script>
